<script setup lang="ts">
  import { computed, ref, watch, defineEmits, nextTick  } from 'vue';
  import { useI18n } from '@/hooks/web/useI18n';
  import { COMMON_OPTIONS } from '@/utils/options'
  
  const { t } = useI18n()
  const props = defineProps({
    modelValue: { type:[String],default:'' },
    disabled:{ type:Boolean, default:false},    
    teleported:{ type:Boolean, default:true},
    showAlpha:{ type:Boolean, default:true},
    size:{ type:String, default:'small'},
    popperClass:{ type:String, default:''},
  })
  const _value = ref<any>()
  const onChangeColor = ()=>{
    emit('update:modelValue', _value.value)
    emit('change', _value.value)
  }

  const emit = defineEmits(['update:modelValue','change']);
  watch(()=>props.modelValue, (val:any) => {
    try{
      _value.value = val
    }catch(error){}
  }, 
  {
    immediate: true,
    deep: true
  })

</script>

<template>
  <el-color-picker 
    v-model="_value" 
    :show-alpha="props.showAlpha" :size="props.size"
    :predefine="COMMON_OPTIONS.colors"
    :teleported="props.teleported"
    :disabled="props.disabled"
    :popper-class="props.popperClass"
    @change="onChangeColor" />
</template>
<style lang="less" scoped>

</style>